var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('p',{staticClass:"copyright"},[_vm._v(" Copyright © 2025 by VIREGA. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }